/** Mieterportal 2.0 (MP-D): Aktionen des Mieters. */
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api, rufe } from "../api/client";
import type { aktionenListe } from "../../worker/data/aktionen";
import type { AktionAnlegen } from "@shared/schemas/aktionen";

export type Aktion = Awaited<ReturnType<typeof aktionenListe>>[number];
export interface AktionenDaten {
  aktionen: Aktion[];
  erlaubt: boolean;
  maxProzent: number;
  kategorien: string[];
}

function nach() {
  const qc = useQueryClient();
  return () => void qc.invalidateQueries({ queryKey: ["mieter"] });
}

export const useAktionen = () => useQuery({ queryKey: ["mieter", "aktionen"], queryFn: () => rufe<AktionenDaten>(api.api.mieter.aktionen.$get()) });
export function useAktionAnlegen() {
  const n = nach();
  return useMutation({ mutationFn: (d: AktionAnlegen) => rufe<{ id: string }>(api.api.mieter.aktionen.$post({ json: d })), onSuccess: n });
}
export function useAktionBeenden() {
  const n = nach();
  return useMutation({ mutationFn: (id: string) => rufe(api.api.mieter.aktionen[":id"].beenden.$post({ param: { id } })), onSuccess: n });
}
